// すでにグローバルにinfinityConfigが存在する場合は再定義しない
if (typeof window.infinityScrollInitialized === 'undefined') {
  window.infinityScrollInitialized = true;

  // 汎用化のための設定
  const infinityConfig = {
    gridSelector: '[data-infinity-grid]',
    itemSelector: '[data-infinity-item]',
    buttonSelector: '.more-button',
    buttonLabelSelector: '.button-label',
    loadingSpinnerSelector: '.loading__spinner',
  };

  let grid, button, buttonLabel, loadingSpinner, handle, allCount, scrollAction, pageType;
  let intersectionObserver;
  let isFetching = false;

  function updateSelectors() {
    grid = document.querySelector(infinityConfig.gridSelector);
    button = document.querySelector(infinityConfig.buttonSelector);
    buttonLabel = button ? button.querySelector(infinityConfig.buttonLabelSelector) : null;
    loadingSpinner = button ? button.querySelector(infinityConfig.loadingSpinnerSelector) : null;
    handle = button ? button.dataset.handle : null;
    allCount = button ? parseInt(button.dataset.totalCount) : 0;
    scrollAction = button ? button.dataset.scrollAction : null;
    pageType = button ? button.dataset.pageType : null;
  }

  function initEventListeners() {
    if (!button) return;
    if (scrollAction === 'scroll') {
      onScroll();
    } else {
      button.addEventListener('click', onClick);
    }
  }

  function onClick() {
    infinityScroll(button);
  }

  function onScroll() {
    const options = { root: null, rootMargin: '0px', threshold: 0.1 };
    intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!grid) return; // gridがnullなら何もしない
        if (entry.isIntersecting && grid.children.length < allCount) {
          infinityScroll(button);
        }
      });
    }, options);
    intersectionObserver.observe(button);
  }

  function getFetchUrl(next) {
    // 現在のクエリパラメータをすべて維持しつつ、pageだけ上書き
    let url = location.pathname;
    let params = new URLSearchParams(location.search);
    params.set('page', next);
    return `${url}?${params.toString()}`;
  }

  async function infinityScroll(button) {
    if (isFetching) return;
    isFetching = true;
    changeLoadingLabel();
    const paginate = parseInt(button.dataset.paginate);
    const current = parseInt(button.dataset.page);
    const next = current + 1;
    try {
      const fetchUrl = getFetchUrl(next);
      const response = await fetch(fetchUrl);
      if (!response.ok) throw new Error('Network response was not ok');
      const text = await response.text();
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(text, 'text/html');
      const gridElement = htmlDocument.querySelector(infinityConfig.gridSelector);
      if (!gridElement) {
        changeDefaultLabel();
        isFetching = false;
        return;
      }
      const items = gridElement.querySelectorAll(infinityConfig.itemSelector);
      const moreButtonInGrid = grid.querySelector(infinityConfig.buttonSelector);
      items.forEach(item => {
        if (moreButtonInGrid) {
          grid.insertBefore(item, moreButtonInGrid);
        } else {
          grid.appendChild(item);
        }
      });

      // ← ここでカラースウォッチのイベントを再バインド
      bindColorSwatchEvents();
      
      if (paginate === next) {
        button.classList.add('hidden');
      } else {
        button.dataset.page = next;
        changeDefaultLabel();
      }
    } catch (error) {
      console.error('Error fetching items:', error);
    } finally {
      isFetching = false;
    }
  }

  function changeLoadingLabel() {
    if (buttonLabel) buttonLabel.classList.add('hidden');
    if (loadingSpinner) loadingSpinner.classList.remove('hidden');
  }
  function changeDefaultLabel() {
    if (buttonLabel) buttonLabel.classList.remove('hidden');
    if (loadingSpinner) loadingSpinner.classList.add('hidden');
  }

  // 初期実行
  updateSelectors();
  initEventListeners();

  // 動的更新対応
  if (!window.infinityScrollObserver) {
    window.infinityScrollObserver = new MutationObserver(() => {
      updateSelectors();
      initEventListeners();
    });
    if (grid) {
      window.infinityScrollObserver.observe(grid, { childList: true, subtree: true });
    }
  }

  // Search & DiscoveryアプリやShopify標準のセクション書き換えイベントにも対応
  function reinitInfinityScroll() {
    // 既存のIntersectionObserverを解除
    if (window.infinityScrollObserver && window.infinityScrollObserver.disconnect) {
      window.infinityScrollObserver.disconnect();
      window.infinityScrollObserver = null;
    }
    // グローバル初期化フラグもリセット
    window.infinityScrollInitialized = undefined;
    // 再度初期化
    setTimeout(function() {
      if (typeof window.infinityScrollInitialized === 'undefined') {
        window.infinityScrollInitialized = true;
        updateSelectors();
        initEventListeners();
        // 再度MutationObserverもセット
        if (!window.infinityScrollObserver) {
          window.infinityScrollObserver = new MutationObserver(() => {
            updateSelectors();
            initEventListeners();
          });
          if (grid) {
            window.infinityScrollObserver.observe(grid, { childList: true, subtree: true });
          }
        }
      }
    }, 100);
  }
  window.addEventListener('shopify:section:load', reinitInfinityScroll);
  window.addEventListener('shopify:section:reorder', reinitInfinityScroll);
  window.addEventListener('facets:updated', reinitInfinityScroll);
}
